import React from 'react';
import { Avatar, Typography, Statistic, Skeleton, Empty } from 'antd';
import { UserOutlined, FileImageOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;

const TopStorageUser = ({ data, loading }) => {
  if (loading) {
    return <Skeleton active avatar paragraph={{ rows: 2 }} />;
  }

  if (!data || !data.user_id) {
    return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No user data" />;
  }

  const {
    display_name = 'N/A',
    email = '',
    image_count = 0,
    total_size_mb = 0,
  } = data;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
      <Avatar size={64} icon={<UserOutlined />}>
        {display_name ? display_name.charAt(0).toUpperCase() : ''}
      </Avatar>
      <Title level={5} style={{ marginTop: 12, marginBottom: 0 }}>
        {display_name}
      </Title>
      <Text type="secondary">{email}</Text>
      <div style={{ marginTop: 16, width: '100%' }}>
        <Statistic
          title="Images Uploaded"
          value={image_count}
          prefix={<FileImageOutlined />}
        />
        {total_size_mb > 0 && (
           <Statistic
            title="Storage Used"
            value={total_size_mb}
            suffix="MB"
            precision={2}
            valueStyle={{fontSize: '16px'}}
          />
        )}
      </div>
    </div>
  );
};

export default TopStorageUser;
